export function StarIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0C23.28 0 30 6.72 30 15C30 23.28 23.28 30 15 30C6.72 30 0 23.28 0 15C0 6.72 6.72 0 15 0Z"
        fill="#00ACEB"
      />
      <path
        d="M15.0002 19.2L12.0102 21.37C11.2602 21.91 10.2502 21.18 10.5402 20.3L11.6802 16.79L8.69021 14.62C7.94021 14.08 8.33021 12.89 9.25021 12.89H12.9402L14.0802 9.37997C14.3702 8.49997 15.6102 8.49997 15.9002 9.37997L17.0402 12.89H20.7302C21.6602 12.89 22.0402 14.07 21.2902 14.62L18.3002 16.79L19.4402 20.3C19.7302 21.18 18.7202 21.91 17.9702 21.37L14.9802 19.2H15.0002Z"
        fill="white"
      />
    </svg>
  )
}
